import React from 'react';
import styled from 'styled-components';
import { EuiIcon } from '@elastic/eui';

const AppGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 190px;
  overflow-y: auto;
  margin: 14px 0;
  padding-right: 4px;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
  }
`;

const AppItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 6px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.08);
  }
  
  .app-name {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #fff;
    font-size: 12px;
  }
  
  .app-version {
    font-family: Consolas, monospace;
    font-size: 11px;
    font-weight: 700;
    color: #48bb78;
    background: rgba(72, 187, 120, 0.1);
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid rgba(72, 187, 120, 0.15);
  }
`;

const NoAppsStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgba(255, 255, 255, 0.35);
  font-size: 12px;
  gap: 8px;
  padding: 20px 10px;
  text-align: center;
`;

const formatAppName = (name) => {
    if (!name) return '';
    const clean = name.replace(/_version$/, '').toLowerCase();
    if (clean === 'docker') return 'Docker';
    if (clean === 'node' || clean === 'nodejs') return 'Node.js';
    if (clean === 'npm') return 'NPM';
    if (clean === 'pm2') return 'PM2';
    if (clean === 'python') return 'Python';
    if (clean === 'pip') return 'PIP';
    if (clean === 'nginx') return 'Nginx';
    if (clean === 'apache') return 'Apache';
    if (clean === 'mysql') return 'MySQL';
    if (clean === 'postgres') return 'PostgreSQL';
    if (clean === 'mongo') return 'MongoDB';
    if (clean === 'redis') return 'Redis';
    if (clean === 'kafka') return 'Kafka';
    if (clean === 'rabbitmq') return 'RabbitMQ';
    if (clean === 'git') return 'Git';
    if (clean === 'go') return 'Go';
    if (clean === 'java') return 'Java';
    if (clean === 'gcc') return 'GCC';
    if (clean === 'gpp') return 'G++';
    if (clean === 'php') return 'PHP';
    if (clean === 'perl') return 'Perl';
    if (clean === 'ruby') return 'Ruby';
    return clean.charAt(0).toUpperCase() + clean.slice(1);
};

const getAppIcon = (name) => {
    const lowercase = name.toLowerCase();
    if (lowercase.includes('docker')) return 'logoTerminal';
    if (lowercase.includes('node')) return 'logoTerminal';
    if (lowercase.includes('python') || lowercase.includes('pip')) return 'logoTerminal';
    if (lowercase.includes('mysql') || lowercase.includes('postgres') || lowercase.includes('mongo') || lowercase.includes('redis')) return 'storage';
    if (lowercase.includes('nginx') || lowercase.includes('apache')) return 'globe';
    if (lowercase.includes('git')) return 'logoTerminal';
    return 'package';
};

const ServerAppsWidget = ({ server }) => {
    const metric = server?.metrics?.[0];
    const appsList = metric?.apps || [];

    if (appsList.length === 0) {
        return (
            <NoAppsStyled>
                <EuiIcon type="package" size="l" style={{ opacity: 0.5 }} />
                <span>No software dependencies detected on host</span>
            </NoAppsStyled>
        );
    }

    return (
        <AppGrid>
            { appsList.map((app, idx) => {
                const displayName = formatAppName(app.name);
                const iconType = getAppIcon(app.name);
                return (
                    <AppItem key={ idx }>
                        <div className="app-name">
                            <EuiIcon type={ iconType } size="s" style={{ opacity: 0.7 }} />
                            <span>{ displayName }</span>
                        </div>
                        <span className="app-version">{ app.version }</span>
                    </AppItem>
                );
            }) }
        </AppGrid>
    );
};

export default ServerAppsWidget;
